// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-micro-left';

export const Component = () => <path d='m9.5 12.598 6-4.597V17z' />;

export const viewBox = '0 0 25 25';
